// Dutch is the default and fallback language - English is an option the
// visitor switches to themselves, not something guessed from their browser.
// Once someone switches, LanguageDetector's localStorage cache remembers it
// on their next visit; until then everyone sees Dutch.
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import nl from './locales/nl.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      nl: { translation: nl },
      en: { translation: en },
    },
    fallbackLng: 'nl',
    supportedLngs: ['nl', 'en'],
    detection: {
      // Only localStorage - no navigator/header sniffing, so a Dutch
      // customer with an English OS still lands on Dutch by default.
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'mosaik_lang',
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
    // Only in dev builds - logs a console warning for any key the app asks
    // for that isn't in either locale file, so a typo'd t() call surfaces
    // immediately instead of silently rendering the raw key.
    debug: process.env.NODE_ENV === 'development',
  });

export default i18n;
